<template>
    <div class="body">
        <div class="slider">
            <img src="../assets/raw-min.webp" alt="ordinateur avec du code de programmation">
            <div class="slider_content">
                <h1>Développeur Web et Mobile</h1>
                <p class="slider_txt">Je développe vos projets WEB et MOBILE sur mesure</p>
            </div>
        </div>
        <div class="bandeau_web">
            <h2 class="bandeau_title" id="devWeb">Développement et Intégration Web</h2>
        </div>
        <div class="dev_txt">
            <h3>Développement de site internet :</h3>
            <p>Je prend en charge le développement de votre site web (site vitrine, corporate, évènementiel, e-commerce,
                intranet) en m’assurant qu’il soit lisible sur tablette et mobile. Nous échangeons en direct pendant la
                phase de développement et un site de pré-production est mis en ligne pour vous permettre de suivre les
                avancées</p>
            <h3>Intégration de maquettes graphiques</h3>
            <p>J’effectue l’intégration responsive de vos maquettes en utilisant les technologies modernes (HTML 5,
                CSS3, JS ES6+) ou en utilisant des frameworks JavaScript type VueJS.</p>
        </div>
        <div class="separation"></div>
        <div class="vuejs_content d-flex flex-row">
            <div class="vuejs_background d-flex flex-row">
                <p class="vuejs_txt">
                    Création de site vitrine et e-commerce 100% personnalisable avec VueJS, le framework JavaScript créé
                    en 2011 par Evan You, ancien développeur chez Google
                </p>
                <div class="vuejs_img">
                    <img src="../assets/vuejsLogo-min.webp" alt="Logo VueJS">
                </div>
            </div>
        </div>
        <div class="separation"></div>
        <div class="wp_content d-flex flex-row">
            <div class="wp_background d-flex flex-row">
                <div class="wp_img">
                    <img src="../assets/wpLogo-min.webp" alt="Logo WordPress">
                </div>
                <p class="wp_txt">
                    Création de site avec WordPress, le framework CMS populaire. Réalisation de site personnalisé avec
                    création ou modification de thème
                </p>
            </div>
        </div>
        <div class="separation"></div>
        <div class="api">
            <div class="api_img">
                <img src="../assets/API-min.webp" alt="Communication entre VueJS et Wordpress (API)">
            </div>
            <div class="api_txt">
                <h3 class="api_title">Sites Headless CMS</h3>
                <p class="api_content">Combinez la performance de VueJS avec le CMS le plus populaire ? Le Headless CMS
                    permet d’avoir une
                    administration de site simple et intuitive tout en ayant le front du site avec un temps de
                    chargement minime, un design 100% personnalisable et flexible.</p>
            </div>
        </div>
        <div class="bandeau_web">
            <h2 class="bandeau_title" id="conception">Conception Graphique et WebDesign</h2>
        </div>
        <div class="ps_content d-flex flex-row">
            <div class="ps_background d-flex flex-row">
                <p class="ps_txt">
                    Réalisation de visuel avec Photoshop et Illustrator pour des concept, création de logo, création
                    d’image de présentation, montage photo.
                </p>
                <div class="ps_img">
                    <img src="../assets/photoshop-illustrator-min.webp" alt="Logo Photoshop et Illustrator">
                </div>
            </div>
        </div>
        <div class="separation"></div>
        <div class="pr_content d-flex flex-row">
            <div class="pr_background d-flex flex-row">
                <div class="pr_img">
                    <img src="../assets/premiere-after-min.webp" alt="Logo Premiere Pro et After Effect">
                </div>
                <p class="pr_txt">
                    Réalisation de montage vidéo avec Premiere Pro et réalisation de motion design et VFX avec After
                    Effect pour toutes vos créations
                </p>
            </div>
        </div>
        <div class="separation"></div>
        <div class="xd_content d-flex flex-row">
            <div class="xd_background d-flex flex-row">
                <p class="xd_txt">
                    Réalisation de maquette Web, Mobile et maquette d'application IOS et Android avec possibilité
                    d'avoir une maquette interactive pour avoir une idée du site final
                </p>
                <div class="xd_img">
                    <img src="../assets/xd-figma-min.webp" alt="Logo Adobe XD et Figma">
                </div>
            </div>
        </div>
        <div class="bandeau_web">
            <h2 class="bandeau_title" id="devMobile">Développement Mobile</h2>
        </div>
        <div class="native_content d-flex flex-row">
            <div class="native_background d-flex flex-row">
                <p class="native_txt">
                    NativeScript est un framework open source pour développer des applications en JavaScript ou
                    TypeScript sur les
                    plateformes iOS et Android.
                </p>
                <div class="native_img">
                    <img src="../assets/NativeScript_logo-min.webp" alt="Logo NativeScript">
                </div>
            </div>
        </div>
        <div class="separation"></div>
        <div class="flutter_content d-flex flex-row">
            <div class="flutter_background d-flex flex-row">
                <div class="flutter_img">
                    <img src="../assets/Flutter-min.webp" alt="Logo Flutter">
                </div>
                <p class="flutter_txt">
                    Flutter est un framework de développement mobile utilisant le langage Dart
                    pour développer des applications pour Android, iOS, Windows, Mac, Linux
                </p>
            </div>
        </div>
        <div class="bandeau_web">
            <h2 class="bandeau_title" id="competences">Compétences</h2>
        </div>
        <div class="competences d-flex flex-column">
            <h2 class="competence_title">Des compétences à votre service</h2>
            <div class="competences_txt d-flex">

                <div class="competence_list">
                    <h3>Domaines de compétences</h3>
                    <h4>Gestion de projets Web</h4>
                    <p>Site vitrine, corporate, évènementiel, e-commerce, intranet, application mobile</p>
                    <h4>Conception graphique et Webdesign</h4>
                    <p>Logos, templates Web, plaquettes publicitaires, cartes de visites, newsletters...</p>
                    <h4>Mise en place / Modification / Gestion de CMS</h4>
                    <p>WordPress</p>
                    <h4>Intégration HTML / CSS</h4>
                    <p>Codage à la main respectueux des standards du Web</p>
                    <h4>Validation W3C, WAI et Référencement SEO</h4>
                    <p>Accessibilité et ergonomie des pages web</p>
                    <h4>Conception Multi-Plateformes</h4>
                    <p>Compatible tous supports, tablette et mobile</p>
                    <h4>Conception d'application mobile</h4>
                    <p>IOS et Android</p>
                    <h4>Réalisation de contenu vidéo</h4>
                    <p>Adobe Premiere Pro et After Effect</p>
                </div>
                <div class="competence_bar">
                    <h3>Domaines de compétences</h3>
                    <mdb-container>
                        <div class="single_bar d-flex">
                            <p class="single_bar_txt">HTML-CSS</p>
                            <mdb-progress class="single_bar_progress" :height="20" :value="85"/>
                        </div>
                        <div class="single_bar d-flex">
                            <p class="single_bar_txt">PHP</p>
                            <mdb-progress class="single_bar_progress" :height="20" :value="40"/>
                        </div>
                        <div class="single_bar d-flex">
                            <p class="single_bar_txt">MySQL - SQL</p>
                            <mdb-progress class="single_bar_progress" :height="20" :value="40"/>
                        </div>
                        <div class="single_bar d-flex">
                            <p class="single_bar_txt">JavaScript</p>
                            <mdb-progress class="single_bar_progress" :height="20" :value="70"/>
                        </div>
                        <div class="single_bar d-flex">
                            <p class="single_bar_txt">VueJS</p>
                            <mdb-progress class="single_bar_progress" :height="20" :value="75"/>
                        </div>
                        <div class="single_bar d-flex">
                            <p class="single_bar_txt">React Native</p>
                            <mdb-progress class="single_bar_progress" :height="20" :value="70"/>
                        </div>
                        <div class="single_bar d-flex">
                            <p class="single_bar_txt">NativeScript</p>
                            <mdb-progress class="single_bar_progress" :height="20" :value="60"/>
                        </div>
                        <div class="single_bar d-flex">
                            <p class="single_bar_txt">Flutter</p>
                            <mdb-progress class="single_bar_progress" :height="20" :value="50"/>
                        </div>
                    </mdb-container>
                    <h3>Compétences en conception graphique</h3>
                    <div class="single_bar d-flex">
                        <p class="single_bar_txt">Photoshop</p>
                        <mdb-progress class="single_bar_progress" :height="20" :value="70"/>
                    </div>
                    <div class="single_bar d-flex">
                        <p class="single_bar_txt">Illustrator</p>
                        <mdb-progress class="single_bar_progress" :height="20" :value="75"/>
                    </div>
                    <div class="single_bar d-flex">
                        <p class="single_bar_txt">InDesign</p>
                        <mdb-progress class="single_bar_progress" :height="20" :value="50"/>
                    </div>
                    <div class="single_bar d-flex">
                        <p class="single_bar_txt">Adobe XD</p>
                        <mdb-progress class="single_bar_progress" :height="20" :value="90"/>
                    </div>
                    <div class="single_bar d-flex">
                        <p class="single_bar_txt">Figma</p>
                        <mdb-progress class="single_bar_progress" :height="20" :value="90"/>
                    </div>
                    <div class="single_bar d-flex">
                        <p class="single_bar_txt">Premiere Pro</p>
                        <mdb-progress class="single_bar_progress" :height="20" :value="80"/>
                    </div>
                    <div class="single_bar d-flex">
                        <p class="single_bar_txt">After Effect</p>
                        <mdb-progress class="single_bar_progress" :height="20" :value="70"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mdbContainer, mdbProgress} from 'mdbvue';

    export default {
        name: "Main",
        components: {
            mdbContainer,
            mdbProgress
        },

    }
</script>

<style scoped>

    .body {
        padding-top: 10vh;
    }

    h1 {
        font-size: 18px;
        font-weight: 900;
        color: #EAEAEA;
        text-align: center;
        padding-top: 2vh;
        width: 100%;
    }

    h2 {
        font-size: 12px;
        font-weight: 400;
    }

    h3 {
        font-size: 12px;
        font-weight: 600;
    }

    h4 {
        font-size: 12px;
        font-weight: 400;
    }

    p {
        font-size: 12px;
        font-weight: 400;
    }

    .slider {
        width: 100%;
    }

    .slider img {
        width: 100%;
    }

    .slider_content {
        position: absolute;
        top: 10vh;
        width: 100%;
    }

    .slider_txt {
        width: 25%;
        text-align: left;
        color: #EAEAEA;
        font-size: 12px;
        font-weight: 400;
        margin-left: 20px;
        margin-top: 15px;
    }

    .bandeau_web {
        background-color: #A52A2A;
        width: 100%;
    }

    .bandeau_title {
        padding-top: 5px;
        padding-bottom: 5px;
        text-align: center;
        font-size: 14px;
        font-weight: 900;
        color: #EAEAEA;
        margin-bottom: 0;
    }

    .dev_txt {
        padding: 20px;
    }

    .separation {
        width: 100%;
        height: 2px;
        background-color: #A52A2A;
    }

    .vuejs_content {
        background-image: url("../assets/VueJS-code-min.webp");
        background-color: #253238;
        background-size: 35%;
        background-repeat: no-repeat;
        background-position-x: 100%;
        background-position-y: 20%;
    }

    .vuejs_background {
        width: 80%;
        -webkit-clip-path: polygon(0 0, 100% 0%, 90% 100%, 0% 100%);
        clip-path: polygon(0 0, 100% 0%, 90% 100%, 0% 100%);
        background-color: #EAEAEA;
        padding: 20px 30px;
        z-index: 0;
    }

    .vuejs_txt {
        width: 80%;
        margin: 0;
    }

    .vuejs_img {
        width: 20%;
    }

    .vuejs_img img {
        width: 100%;
    }

    .wp_content {
        background-image: url("../assets/WpPanel-min.webp");
        background-color: #EAEAEA;
        background-size: 60%;
        background-repeat: no-repeat;
        background-position-x: 0;
        background-position-y: 0;
    }

    .wp_background {
        width: 80%;
        -webkit-clip-path: polygon(0 0, 100% 0%, 100% 100%, 10% 100%);
        clip-path: polygon(0 0, 100% 0%, 100% 100%, 10% 100%);
        background-color: #EAEAEA;
        padding: 20px 30px;
        z-index: 0;
        margin-left: 20%;
    }

    .wp_txt {
        width: 80%;
        margin: 0;
    }

    .wp_img {
        width: 20%;
        margin-right: 1rem;
    }

    .wp_img img {
        width: 100%;
    }

    .api_img {
        width: 100%;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .api_img img {
        width: 50%;
    }

    .api_title {
        width: 100%;
        text-align: center;
    }

    .api_txt {
        text-align: left;
        margin: 10px 20px;
    }

    .ps_content {
        background-image: url("../assets/illustrator-min.webp");
        background-color: #253238;
        background-size: 45%;
        background-repeat: no-repeat;
        background-position-x: 116%;
    }

    .ps_background {
        width: 80%;
        -webkit-clip-path: polygon(0 0, 100% 0%, 90% 100%, 0% 100%);
        clip-path: polygon(0 0, 100% 0%, 90% 100%, 0% 100%);
        background-color: #EAEAEA;
        padding: 20px 30px;
        z-index: 0;
    }

    .ps_txt {
        width: 80%;
        margin: 0;
    }

    .ps_img {
        width: 30%;
    }

    .ps_img img {
        width: 100%;
    }

    .pr_content {
        background-image: url("../assets/premiere-min.webp");
        background-color: #EAEAEA;
        background-size: 50%;
        background-repeat: no-repeat;
        background-position-x: 0;
        background-position-y: 0;
    }

    .pr_background {
        width: 80%;
        -webkit-clip-path: polygon(0 0, 100% 0%, 100% 100%, 10% 100%);
        clip-path: polygon(0 0, 100% 0%, 100% 100%, 10% 100%);
        background-color: #EAEAEA;
        padding: 20px 30px;
        z-index: 0;
        margin-left: 20%;
    }

    .pr_txt {
        width: 80%;
        margin: 0;
    }

    .pr_img {
        width: 30%;
        margin-right: 1rem;
    }

    .pr_img img {
        width: 100%;
    }

    .xd_content {
        background-image: url("../assets/maquette-min.webp");
        background-color: #253238;
        background-size: 60%;
        background-repeat: no-repeat;
        background-position-x: 130%;
        background-position-y: 20%;
    }

    .xd_background {
        width: 80%;
        -webkit-clip-path: polygon(0 0, 100% 0%, 90% 100%, 0% 100%);
        clip-path: polygon(0 0, 100% 0%, 90% 100%, 0% 100%);
        background-color: #EAEAEA;
        padding: 20px 30px;
        z-index: 0;
    }

    .xd_txt {
        width: 80%;
        margin: 0;
    }

    .xd_img {
        width: 20%;
    }

    .xd_img img {
        width: 100%;
    }

    .native_content {
        background-image: url("../assets/applications-mobiles-min.webp");
        background-color: #253238;
        background-size: 35%;
        background-repeat: no-repeat;
        background-position-x: 100%;
        background-position-y: 20%;
    }

    .native_background {
        width: 80%;
        -webkit-clip-path: polygon(0 0, 100% 0%, 90% 100%, 0% 100%);
        clip-path: polygon(0 0, 100% 0%, 90% 100%, 0% 100%);
        background-color: #EAEAEA;
        padding: 20px 30px;
        z-index: 0;
    }

    .native_txt {
        width: 80%;
        margin: 0;
    }

    .native_img {
        width: 13%;
        margin-left: 1rem;
    }

    .native_img img {
        width: 100%;
    }

    .flutter_content {
        background-image: url("../assets/appli-flutter-min.webp");
        background-color: #EAEAEA;
        background-size: 65%;
        background-repeat: no-repeat;
        background-position-x: 0;
        background-position-y: 0;
    }

    .flutter_background {
        width: 80%;
        -webkit-clip-path: polygon(0 0, 100% 0%, 100% 100%, 10% 100%);
        clip-path: polygon(0 0, 100% 0%, 100% 100%, 10% 100%);
        background-color: #EAEAEA;
        padding: 20px 30px;
        z-index: 0;
        margin-left: 20%;
    }

    .flutter_txt {
        width: 80%;
        margin: 0;
    }

    .flutter_img {
        width: 25%;
        margin-right: 1rem;
    }

    .flutter_img img {
        width: 100%;
    }

    .competences_txt {
        width: 100%;
        flex-direction: column;
    }

    .competence_title {
        text-align: center;
        margin-top: 15px;
        margin-bottom: 20px;
    }

    .competence_list {
        margin-left: 20px;
        margin-right: 20px;
    }

    .competence_list h4 {
        margin-left: 23px;
        margin-bottom: 10px;
        margin-top: 15px;
        font-weight: 600;
    }

    .competence_list p {
        margin: 15px 20px 10px 23px;
    }

    .competence_bar {
        margin-left: 20px;
        margin-right: 20px;
    }

    .container {
        padding: 0;
        max-width: 100%;
    }

    .single_bar_txt {
        width: 20%;
        height: 20px;
        background-color: #363636;
        color: #ffffff;
        text-align: center;
        line-height: 20px;
    }

    .single_bar_progress {
        width: 100%;
    }

    @media (min-width: 576px) {

        h3 {
            font-size: 16px;
        }

        h4 {
            font-size: 16px;
        }

        p {
            font-size: 14px;
        }

        .slider_txt {
            font-size: 16px;
        }

        .bandeau_title {
            font-size: 18px;
            padding-top: 10px;
            padding-bottom: 10px;
        }

        .separation {
            height: 3px;
        }

        .vuejs_content {
            background-size: 30%;
        }

        .vuejs_background {
            padding: 20px 50px 20px 30px;
        }

        .vuejs_img {
            width: 15%;
        }

        .wp_content {
            background-size: 55%;
        }

        .wp_background {
            padding: 20px 30px 20px 50px;
        }

        .wp_img {
            width: 15%;
        }

        .ps_content {
            background-size: 30%;
            background-position-x: 100%;
        }

        .ps_background {
            padding: 20px 50px 20px 30px;
        }

        .pr_content {
            background-size: 45%;
        }

        .pr_background {
            padding: 20px 30px 20px 50px;
        }

        .xd_background {
            padding: 20px 50px 20px 30px;
        }

        .native_content {
            background-size: 25%;
        }

        .native_background {
            padding: 20px 50px 20px 30px;
        }

        .flutter_content {
            background-size: 45%;
        }

        .flutter_background {
            padding: 20px 30px 20px 50px;
        }

        .flutter_img {
            width: 20%;
        }

        .competence_title {
            font-size: 16px;
        }

        .competence_list {
            margin-left: 30px;
            margin-right: 30px;
        }

        .competence_list h4 {
            margin-left: 23px;
            margin-bottom: 10px;
            margin-top: 15px;
        }

        .competence_list p {
            margin: 15px 20px 10px 23px;
        }

        .competence_bar {
            margin-left: 30px;
            margin-right: 30px;
        }
    }

    @media (min-width: 768px) {
        h1 {
            font-size: 24px;
        }

        h3 {
            font-size: 18px;
            font-weight: 600;
        }

        h4 {
            font-size: 18px;
        }

        p {
            font-size: 16px;
        }

        .slider_txt {
            font-size: 18px;
        }

        .bandeau_title {
            font-size: 20px;
            padding-top: 15px;
            padding-bottom: 15px;
        }

        .vuejs_content {
            background-size: 25%;
            background-position-y: 24%;
        }

        .vuejs_background {
            padding: 20px 30px 20px 30px;
        }

        .wp_background {
            padding: 20px 30px 20px 70px;
        }

        .wp_img {
            width: 15%;
        }

        .pr_content {
            background-size: 30%;
        }

        .pr_background {
            padding: 20px 30px 20px 70px;
        }

        .xd_background {
            padding: 20px 70px 20px 30px;
        }

        .native_content {
            background-size: 20%;
        }

        .native_background {
            padding: 20px 50px 20px 30px;
        }

        .flutter_content {
            background-size: 45%;
        }

        .flutter_background {
            padding: 20px 30px 20px 50px;
        }

        .flutter_img {
            width: 15%;
        }

        .competences_txt {
            width: 100%;
            flex-direction: column;
        }

        .competence_title {
            font-size: 24px;
            font-weight: 600;
        }

        .competence_list {
            margin-left: 50px;
            margin-right: 50px;
        }

        .competence_list h4 {
            margin-left: 33px;
            margin-bottom: 20px;
            margin-top: 25px;
        }

        .competence_list p {
            margin: 25px 20px 20px 33px;
        }

        .competence_bar {
            margin-left: 50px;
            margin-right: 50px;
        }

        .single_bar_txt {
            height: 40px;
            line-height: 40px;
        }

        .single_bar_progress {
            height: 40px !important;
        }

    }

    @media (min-width: 992px) {
        h1 {
            font-size: 26px;
        }

        h3 {
            font-size: 20px;
            font-weight: 600;
        }

        h4 {
            font-size: 20px;
        }

        p {
            font-size: 18px;
        }

        .slider_txt {
            font-size: 20px;
        }

        .bandeau_title {
            font-size: 20px;
            padding-top: 20px;
            padding-bottom: 20px;
        }

        .vuejs_background {
            width: 85%;
            padding: 20px 30px 20px 30px;
        }

        .wp_background {
            width: 85%;
            padding: 20px 30px 20px 70px;
            margin-left: 15%;
        }

        .wp_img {
            width: 15%;
        }

        .ps_background{
            width: 85%;
        }

        .pr_content {
            background-size: 30%;
        }

        .pr_background {
            width: 85%;
            padding: 20px 30px 20px 70px;
            margin-left: 15%;
        }

        .xd_background {
            width: 85%;
            padding: 20px 70px 20px 30px;
        }

        .native_content {
            background-size: 20%;
        }

        .native_background {
            width: 85%;
            padding: 20px 50px 20px 30px;
        }

        .flutter_content {
            background-size: 45%;
        }

        .flutter_background {
            width: 85%;
            padding: 20px 30px 20px 50px;
            margin-left: 15%;
        }

        .flutter_img {
            width: 15%;
        }

        .competences_txt {
            flex-direction: row;
            padding-left: 50px;
            padding-right: 50px;
        }

        .competence_title {
            font-size: 24px;
            font-weight: 600;
        }

        .competence_list {
            margin-left: 0;
            margin-right: 0;
            padding-right: 40px;
            width: 50%;
        }

        .competence_list h4 {
            margin-left: 33px;
            margin-bottom: 20px;
            margin-top: 25px;
        }

        .competence_list p {
            margin: 25px 20px 20px 33px;
        }

        .competence_bar {
            margin-left: 0;
            margin-right: 0;
            width: 50%;
        }

        .single_bar_txt {
            width: 30%;
            height: 20px;
            line-height: 20px;
            font-size: 16px;
        }

        .single_bar_progress {
            height: 20px !important;
        }
    }

    @media (min-width: 1200px) {
        h1 {
            font-size: 48px;
        }

        h3 {
            font-size: 24px;
            font-weight: 600;
        }

        h4 {
            font-size: 20px;
        }

        p {
            font-size: 18px;
        }

        .slider_txt {
            font-size: 36px;
            margin-left: 50px;
            margin-top: 95px;
        }

        .bandeau_title {
            font-size: 28px;
            padding-top: 25px;
            padding-bottom: 25px;
        }

        .dev_txt {
            margin-left: 100px;
            margin-right: 100px;
        }

        .vuejs_background {
            width: 85%;
            padding: 20px 30px 20px 100px;
        }

        .wp_background {
            width: 85%;
            padding: 20px 100px 20px 100px;
            margin-left: 15%;
        }

        .wp_img {
            width: 15%;
        }

        .api_txt {
            margin: 50px 100px;
        }

        .ps_background{
            width: 85%;
            padding: 20px 100px 20px 100px;
        }

        .ps_content {
            background-size: 24%;
        }

        .pr_content {
            background-size: 25%;
        }

        .pr_background {
            width: 85%;
            padding: 20px 100px 20px 70px;
            margin-left: 15%;
        }

        .xd_background {
            width: 85%;
            padding: 20px 100px 20px 100px;
        }

        .native_content {
            background-size: 20%;
        }

        .native_background {
            width: 85%;
            padding: 20px 50px 20px 100px;
        }

        .flutter_content {
            background-size: 35%;
        }

        .flutter_background {
            width: 85%;
            padding: 20px 30px 20px 100px;
            margin-left: 15%;
        }

        .flutter_img {
            width: 15%;
        }

        .competences_txt {
            flex-direction: row;
            padding-left: 100px;
            padding-right: 100px;
        }

        .competence_title {
            font-size: 24px;
            font-weight: 600;
        }

        .competence_list {
            margin-left: 0;
            margin-right: 0;
            padding-right: 40px;
            width: 50%;
        }

        .competence_list h4 {
            margin-left: 33px;
            margin-bottom: 20px;
            margin-top: 25px;
        }

        .competence_list p {
            margin: 25px 20px 20px 33px;
        }

        .competence_bar {
            margin-left: 0;
            margin-right: 0;
            width: 50%;
        }

        .single_bar_txt {
            width: 30%;
            height: 20px;
            line-height: 20px;
            font-size: 16px;
        }

        .single_bar_progress {
            height: 20px !important;
        }
    }

    @media (min-width: 1600px) {

        .vuejs_img {
            width: 10%;
        }

        .wp_background {
            width: 85%;
            padding: 20px 100px 20px 160px;
            margin-left: 15%;
        }

        .wp_img {
            width: 10%;
        }

        .api_img img {
            width: 30%;
        }

        .api_txt {
            margin: 50px 100px;
        }

        .ps_background{
            width: 85%;
            padding: 20px 160px 20px 100px;
        }

        .ps_content {
            background-size: 24%;
        }

        .ps_img {
            width: 30%;
        }

        .pr_content {
            background-size: 25%;
        }

        .pr_background {
            width: 85%;
            padding: 20px 100px 20px 160px;
            margin-left: 15%;
        }

        .pr_img {
            width: 30%;
            margin-right: 1rem;
        }

        .xd_content {
            background-size: 40%;
            background-position-x: 110%;
        }

        .xd_background {
            width: 85%;
            padding: 20px 160px 20px 100px;
        }

        .xd_img {
            width: 20%;
        }

        .native_content {
            background-size: 15%;
            background-position-x: 99%;
        }

        .native_background {
            width: 85%;
            padding: 20px 160px 20px 100px;
        }

        .native_img {
            width: 10%;
            margin-left: 1rem;
        }

        .flutter_content {
            background-size: 25%;
        }

        .flutter_background {
            width: 85%;
            padding: 20px 100px 20px 160px;
            margin-left: 15%;
        }

        .flutter_img {
            width: 10%;
        }

        .competences_txt {
            flex-direction: row;
            padding-left: 100px;
            padding-right: 100px;
        }

        .competence_title {
            font-size: 24px;
            font-weight: 600;
        }

        .competence_list {
            margin-left: 0;
            margin-right: 0;
            padding-right: 40px;
            width: 50%;
        }

        .competence_list h4 {
            margin-left: 33px;
            margin-bottom: 20px;
            margin-top: 25px;
        }

        .competence_list p {
            margin: 25px 20px 20px 33px;
        }

        .competence_bar {
            margin-left: 0;
            margin-right: 0;
            width: 50%;
        }

        .single_bar_txt {
            width: 20%;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
        }

        .single_bar_progress {
            height: 30px !important;
        }
    }


</style>